import "bootstrap-icons/font/bootstrap-icons.css?bundle=public";
import "../scss/styles.scss";
import Pbkdf2Worker from "altcha/workers/pbkdf2?worker";
import ShaWorker from "altcha/workers/sha?worker";

window.addEventListener("load", () => {
//add 100ms delay to ensure all critical assets are loaded and rendered before starting the deferred runtime, improving perceived performance and avoiding jank during initial load
    setTimeout(() => {
        startDeferredPublicRuntime().catch(error => { 

            console.error("Error starting public runtime:", error);
        });
    }, 100);

    //void startDeferredPublicRuntime();
});

async function startDeferredPublicRuntime(): Promise<void> {
    await loadConditionalPublicAssets();

    const [bootstrap, htmxModule, publicSiteRuntimeModule] = await Promise.all([
        import("bootstrap"),
        import("htmx.org"),
        import("./public-site-runtime"),
        import("./cookie-consent")
    ]);

    window.htmx = htmxModule.default;
    window.bootstrap = bootstrap;

    publicSiteRuntimeModule.startPublicSiteRuntime();
}

async function loadConditionalPublicAssets(): Promise<void> {
    const assetLoadTasks: Promise<unknown>[] = [];

    if (document.querySelector(".swiper")) {
        assetLoadTasks.push(loadSwiperAssets());
    }

    if (document.querySelector(".glightbox, [data-glightbox], [data-gallery], [data-lightbox='true']")) {
        assetLoadTasks.push(loadGlightboxAssets());
    }

    if (document.querySelector("altcha-widget, .altcha, [data-altcha]")) {
        assetLoadTasks.push(loadAltchaAssets());
    }

    await Promise.all(assetLoadTasks);
}

async function loadSwiperAssets(): Promise<void> {
    await Promise.all([
        import("swiper/css"),
        import("swiper/css/pagination"),
        import("swiper/css/navigation"),
        import("swiper/css/scrollbar"),
        import("swiper/css/grid"),
        import("swiper/css/free-mode")
    ]);
}

async function loadGlightboxAssets(): Promise<void> {
    await import("glightbox/dist/css/glightbox.css");
}

async function loadAltchaAssets(): Promise<void> {
    await Promise.all([
        import("altcha/altcha.css"),
        import("altcha/external"),
        import("altcha/i18n/all")
    ]);

    $altcha.algorithms.set("SHA-256", () => new ShaWorker());
    $altcha.algorithms.set("SHA-384", () => new ShaWorker());
    $altcha.algorithms.set("SHA-512", () => new ShaWorker());
    $altcha.algorithms.set("PBKDF2/SHA-256", () => new Pbkdf2Worker());
    $altcha.algorithms.set("PBKDF2/SHA-384", () => new Pbkdf2Worker());
    $altcha.algorithms.set("PBKDF2/SHA-512", () => new Pbkdf2Worker());
}
